export function PluzeIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6.5 3.5C6.5 2.11929 7.61929 1 9 1C10.3807 1 11.5 2.11929 11.5 3.5V5H12.5C13.8978 5 14.5967 5 15.1481 5.22836C15.8831 5.53284 16.4672 6.11687 16.7716 6.85195C17 7.40326 17 8.10218 17 9.5H18.5C19.8807 9.5 21 10.6193 21 12C21 13.3807 19.8807 14.5 18.5 14.5H17V16.2C17 17.8802 17 18.7202 16.673 19.362C16.3854 19.9265 15.9265 20.3854 15.362 20.673C14.7202 21 13.8802 21 12.2 21H11.5V19.25C11.5 18.0074 10.4926 17 9.25 17C8.00736 17 7 18.0074 7 19.25V21H5.8C4.11984 21 3.27976 21 2.63803 20.673C2.07354 20.3854 1.6146 19.9265 1.32698 19.362C1 18.7202 1 17.8802 1 16.2V14.5H2.5C3.88071 14.5 5 13.3807 5 12C5 10.6193 3.88071 9.5 2.5 9.5H1C1 8.10218 1 7.40326 1.22836 6.85195C1.53284 6.11687 2.11687 5.53284 2.85195 5.22836C3.40326 5 4.10218 5 5.5 5H6.5V3.5Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
